@if (isFetching()) {
  <div class="loading">Chargement…</div>
}

@if (!isFetching()) {
  <div class="fiche-container animate-fade-in">

    <!-- Page header -->
    <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 md:pt-8 px-2 md:px-4">
      <div class="justify-self-start">
        <button (click)="onCancel()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux revues de presse</span>
        </button>
      </div>
      <div class="justify-self-center">
        <h1 class="page-title">{{ pageTitle }}</h1>
      </div>
      <div class="justify-self-end"></div>
    </div>

    @if (errorMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    }
    @if (successMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-emerald-50 border border-emerald-100 text-sm text-emerald-700 flex items-center gap-3">
        <span class="material-icons text-base text-emerald-500">check_circle</span>
        {{ successMessage() }}
      </div>
    }

    <form (ngSubmit)="onSave()">
      <div class="fiche-content-area space-y-6">

        <!-- Informations de l'article -->
        <div class="fiche-section">
          <div class="fiche-section-title">Informations de l'article</div>
          <div class="fiche-section-box">
            <div class="fiche-grid">

              <div class="fiche-field">
                <span class="fiche-label-fixed">Titre <span class="text-red-500">*</span></span>
                <input type="text"
                  [value]="formData().title_ln1"
                  (input)="updateField('title_ln1', $any($event.target).value)"
                  maxlength="255"
                  placeholder="Titre de l'article"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Source</span>
                <input type="text"
                  [value]="formData().source_ln1 || ''"
                  (input)="updateField('source_ln1', $any($event.target).value)"
                  maxlength="100"
                  placeholder="Nom de la source (ex: L'Équipe)"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Date <span class="text-red-500">*</span></span>
                <input type="date"
                  [value]="formData().publish_date"
                  (input)="updateField('publish_date', $any($event.target).value)"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Lien article <span class="text-red-500">*</span></span>
                <input type="url"
                  [value]="formData().article_url"
                  (input)="updateField('article_url', $any($event.target).value)"
                  maxlength="255"
                  placeholder="https://..."
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Tags</span>
                <app-tag-input module="REVUE_PRESSE" [value]="formData().press_tags || ''" (valueChange)="updateField('press_tags', $event)"></app-tag-input>
              </div>

            </div>
          </div>
        </div>

        <!-- Résumé -->
        <div class="fiche-section">
          <div class="fiche-section-title">Résumé / Extrait</div>
          <div class="fiche-section-box">
            <div class="fiche-field full-width">
              <span class="fiche-label-fixed">Extrait</span>
              <textarea
                [value]="formData().snippet || ''"
                (input)="updateField('snippet', $any($event.target).value)"
                placeholder="Bref extrait ou résumé de l'article (optionnel)"
                rows="4"
                maxlength="500"
                autoDir class="fiche-input resize-none"></textarea>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end gap-3 pt-2">
          <button type="button" (click)="onCancel()" [disabled]="isLoading()"
            class="px-5 py-2.5 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors text-sm font-medium">
            Annuler
          </button>
          <button type="submit" [disabled]="isLoading()"
            class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-semibold shadow-sm shadow-primary-600/10">
            @if (isLoading()) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            } @else {
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            }
            {{ isLoading() ? 'Enregistrement…' : 'Enregistrer' }}
          </button>
        </div>

      </div>
    </form>
  </div>
}
